import Holidays from 'date-holidays-parser'
import {t} from '@eitje/bridge'
import {HOLIDAYS_TAXONOMY} from './constants'

export {useHolidaySettings} from './use_holiday_settings'

// We only use date-holidays-parser as a rule engine. Instead of loading generated
// date-holidays country data, we start with an empty parser and register our own product list.

const parser = new Holidays({holidays: {}, names: {}})

// The parser won't initialize (it errors) without setting 'rule' and 'type'. The type is not actually being used, so the choice for 'observance' is arbitrary.
// We need to set 'name' for the parser methods (getHolidays(), isHoliday()) to work.
HOLIDAYS_TAXONOMY.forEach(holiday => parser.setHoliday(holiday.rule, {name: holiday.id, type: 'observance'}))

const buildHolidayObjects = holidaysFromParser => {
	return holidaysFromParser.map(holidayFromParser => {
		const {id, allowance_id} = HOLIDAYS_TAXONOMY.find(holiday => holiday.id === holidayFromParser.name)

		return {id, name: t(`holidays.${id}`), allowance_id}
	})
}

export const getAllHolidays = () => {
	const holidaysFromParser = parser.getHolidays()
	return buildHolidayObjects(holidaysFromParser)
}

export const getHolidaysByDate = date => {
	const holidaysFromParser = parser.isHoliday(date) || []
	return buildHolidayObjects(holidaysFromParser)
}
